/*
Function that formats the phone number with spacing. Format: "XXX XX XXX"
*/
export const getFormatedPhoneNumber = (phoneNumber: string) => {
  if (phoneNumber.length === 8) {
    return `${phoneNumber.replace(/\D*(\d{3})\D*(\d{2})\D*(\d{3})\D*/, "$1 $2 $3")}`;
  }
  return "";
};
